module.exports = __webpack_public_path__ + "img/symbol_1.3397aaf4.png";